import React from "react";
import { useState, useEffect } from "react";
import api from "../../api";
import UserSideNav from "../components/UserSideNav";
import { GiHamburgerMenu } from "react-icons/gi";
import { BiLogOut } from "react-icons/bi";
import userDashLinks from "./userDashLinks";

const UserWallets = () => {
  const [navActive, updateNavActive] = useState(null);

  useEffect(() => {
    if (navActive) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [navActive]);

  const clearSess = async () => {
    try {
      await api.post("/api/logout");
    } catch (e) {}
    window.sessionStorage.clear();
  };

  const hideNav = () => {
    updateNavActive(false);
  };

  return (
    <div className="absolute overflow-hidden w-full min-h-full text-white bg-black">
      <UserSideNav
        hideNav={hideNav}
        logout="/signin"
        logoutBtn={clearSess}
        translateAction={
          navActive ? `translate-x-[0px]` : `translate-x-[-500px]`
        }
        clearSess={clearSess}
        backgroundColor="bg-black"
        arrowCoLor="text-white"
        iconBorderColor="border-white"
        iconBgColor="bg-inherit"
        textColor="text-white"
        links={userDashLinks}
        logouticon={
          <BiLogOut className="cursor-pointer text-[20px] text-white transition-all ease-in duration-300 hover:scale-[1.1] md:text-[25px]" />
        }
      />

      {navActive && (
        <div
          className="fixed inset-0 bg-black/60 z-40 xl:hidden"
          onClick={hideNav}
        />
      )}

      <div className="relative w-full h-full p-4 overflow-hidden mb-[100px] xl:pl-[304px] xl:pr-6">
        <nav className="relative w-full min-h-[100px] flex justify-center items-start">
          <div className="relative w-full min-h-[50px] flex justify-between items-center">
            <button
              onClick={() => updateNavActive(true)}
              className="relative xl:hidden"
            >
              <GiHamburgerMenu className="text-[20px] text-[#A9ABAD]" />
            </button>
          </div>
        </nav>

        <div className="relative min-h-[300px] w-full flex flex-col justify-center items-center space-y-4 bg-black py-[1.5rem] px-4 border border-black rounded-md">
          <p className="text-[#A9ABAD] text-[14px]">No wallets connected.</p>
        </div>
      </div>
    </div>
  );
};

export default UserWallets;
